import { useState } from 'react';

type AccordionItemProps = {
  isExpanded?: boolean;
  onToggle?: () => any;
  children: any;
};

export const Accordion = ({ children }: any) => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleToggle = (index: any) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  return children.map((child: any, index: any) => ({
    ...child,
    props: {
      ...child.props,
      isExpanded: activeIndex === index,
      onToggle: () => {
        handleToggle(index);
      },
    },
  }));
};

Accordion.Header = ({ renderHeader, onToggle, isExpanded }: any) => renderHeader(onToggle, isExpanded);

Accordion.Body = ({ renderBody, isExpanded }: any) => renderBody(isExpanded);

Accordion.Item = ({ isExpanded, onToggle, children }: AccordionItemProps) =>
  // eslint-disable-next-line array-callback-return
  children.map((child: any) => {
    if (child.type === Accordion.Header) {
      return { ...child, props: { ...child.props, isExpanded, onToggle } };
    }

    if (child.type === Accordion.Body) {
      return { ...child, props: { ...child.props, isExpanded } };
    }
  });
